import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useModal } from "../_contexts";
import { Button, Icon } from "./";

export function MapPicker({
  value,
  onChange,
  allowNew,
  preNew,
  labelText,
  labelTarget,
  showTooltip = false,
  tooltipID,
  tooltipText,
  tooltipIcon,
}) {
  const [searchVal, setSearchVal] = useState("");
  const [filteredMaps, setFilteredMaps] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const { items: maps } = useSelector((state) => state.maps);
  const { activeModal, openModal } = useModal();
  const handleSearchChange = (ev) => {
    const { value } = ev.target;
    setSearchVal(value);
  };
  const handleChange = (mapID) => {
    const activeMap = maps.find((m) => m._id === mapID);
    setActiveItem(activeMap);
    console.log("Active Map: ", activeMap);
  };
  const updateValue = () => {
    if (onChange) {
      onChange(activeItem && activeItem._id ? activeItem._id : "");
    }
  };
  const handlePreChange = (ev) => {
    if (preNew) {
      const data = preNew();
      const params = {
        prevForm: data,
        prevModal: activeModal,
      };
      openModal("newMap", params);
    }
  };
  useEffect(() => {
    if (maps) {
      setFilteredMaps(maps);
    }
  }, [maps]);
  useEffect(() => {
    if (searchVal && searchVal.length > 0) {
      const query = searchVal.toLowerCase();
      const result = maps.filter((map) => {
        if (map.title.toLowerCase().indexOf(query) > -1) {
          return true;
        }
        return false;
      });
      setFilteredMaps(result);
    } else {
      setFilteredMaps(maps);
    }
  }, [searchVal]);
  useEffect(() => {
    if (maps && value) {
      const activeMap = maps.find((map) => map._id === value);
      setActiveItem(activeMap);
    }
  }, [value]);
  return (
    <div className="chronos-map-picker-component">
      <div className="chronos-map-picker-header">
        {labelText && (
          <label htmlFor={labelTarget || null} className="chronos-form-title">
            {labelText}
            {showTooltip && (
              <React.Fragment>
                &nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-for={tooltipID}
                  data-tip={tooltipText}
                />
              </React.Fragment>
            )}
          </label>
        )}
        {!labelText && <React.Fragment>&nbsp;</React.Fragment>}
        {allowNew && (
          <Button color="success" size="xs" onClick={handlePreChange}>
            <Icon icon="far fa-map fa-fw" />
            &nbsp;Create a new map
          </Button>
        )}
      </div>
      <div className="chronos-map-picker-container">
        <div className="chronos-map-picker-maps">
          <div className="chronos-list-search">
            <input
              type="text"
              value={searchVal}
              onChange={handleSearchChange}
              className="form-control chronos-form-control chronos-search-input"
              placeholder="Filter Maps"
            />
            <Icon icon="fas fa-search fa-fw" />
          </div>
          <div className="chronos-list-results chronos-map-results">
            {filteredMaps.map((map) => {
              // const mapImage = images.find((i) => i._id === map.image);
              return (
                <MapListItem
                  map={map}
                  image={map.image}
                  key={map._id}
                  active={value === map._id}
                  click={handleChange}
                />
              );
            })}
          </div>
        </div>
        <div className="chronos-map-picker-sidebar">
          {activeItem && activeItem !== null && (
            <div className="chronos-map-picker-sidebar-details">
              {activeItem.image && activeItem.image.url && (
                <div className="chronos-map-details-preview">
                  <img src={activeItem.image.url} alt={activeItem.title} />
                </div>
              )}
              {/* <h3>
                <Icon icon="far fa-info-circle fa-fw" />
                &nbsp;{activeItem.title}
              </h3> */}
            </div>
          )}
          <div className="chronos-map-picker-sidebar-footer">
            {/* {allowNew && (
            <React.Fragment>
              <span className="chronos-map-picker-manager-text">
                <Icon icon="fal fa-question-circle fa-fw" />
                &nbsp; Need to add a Map?
              </span>
              <Button color="info" size="xs" onClick={handlePreChange}>
                <Icon icon="far fa-map fa-fw" />
                &nbsp;New Map
              </Button>
            </React.Fragment>
          )} */}
            {activeItem && activeItem !== null && (
              <Button color="primary" block onClick={updateValue}>
                {activeItem._id === value && (
                  <React.Fragment>
                    <Icon icon="far fa-check fa-fw" />
                    &nbsp;Selected
                  </React.Fragment>
                )}
                {activeItem._id !== value && (
                  <React.Fragment>
                    <Icon icon="far fa-check fa-fw" />
                    &nbsp;Select
                  </React.Fragment>
                )}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function MapListItem({ map, image, active, click }) {
  let classes = ["chronos-map-picker-item"];
  if (active) {
    classes.push("chronos-map-item-active");
  }
  const handleClick = (ev) => {
    click(map._id);
  };
  return (
    <div className={classes.join(" ")} onClick={handleClick}>
      <div className="chronos-map-picker-item-thumb">
        {image && image !== null && (
          <img src={image.url} alt={image.title || map.title} />
        )}
      </div>
      <div className="chronos-map-picker-item-details">
        <h3>{map.title}</h3>
      </div>
    </div>
  );
}
